import { render, staticRenderFns } from "./IconMessageSky.vue?vue&type=template&id=5f8908e2&"
import script from "./IconMessageSky.vue?vue&type=script&lang=js&"
export * from "./IconMessageSky.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports